module.exports = __webpack_public_path__ + "so.svg?5806dcad25962d29cca27fa7eddf7191";